// Types
import { RootState } from "@/redux/store";

// Queries
import { getPaginatedNotifications } from "@/Common/api/notifications/queries";

// Hooks
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

// Constants
import { NOTIFICATIONS_STALE_TIME } from "@/Common/hooks/Notifications/constants";

export const useNotificationInfo = () => {
	const userId = useSelector((state: RootState) => state.user.user?._id);
	const locationId = useSelector((state: RootState) => state.location.location?.locationId);

	const { data: notificationInfo, ...otherResults } = useQuery({
		queryKey: ["notificationsInfo", userId, locationId],
		queryFn: async () => {
			if (!userId || !locationId) {
				throw new Error("Cant request notifications without a logged user, or location");
			}
			const paginatedResponse = await getPaginatedNotifications({
				locationId,
				onlyUnRead: false,
				after: "",
				first: 0,
			});

			return paginatedResponse.pageInfo;
		},
		staleTime: NOTIFICATIONS_STALE_TIME,
	});

	return { notificationInfo, ...otherResults };
};
